import firebase from "firebase";

export const ip = async ipAddress => {
  let callable = firebase.functions().httpsCallable("ip");
  return callable({ ipAddress }).then(result => result.data);
};
export const getFileAsText = async url => {
  let callable = firebase.functions().httpsCallable("getFileAsText");
  return callable(url).then(result => result.data);
};
